import global from '@/global'

export default async (url = '', data = {}, type = 'GET') => {
  type = type.toUpperCase()
  if (type === 'GET') {
    let dataStr = '' // 数据拼接字符串
    Object.keys(data).forEach(key => {
      dataStr += key + '=' + data[key] + '&'
    })

    if (dataStr !== '') {
      dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
      url = url + '?' + dataStr
    }
  }

  let instance = await global.createAxios().request({
    method: type,
    url: url,
    data: type === 'GET' ? null : data
  })

  return instance.data
}
